"use strict";

require("core-js/modules/es.array.iterator");

var reduceS = require("./reduceS.js");

var go1Sync = require("../.internal/go1Sync.js");

module.exports = pipeS;

function pipeS(f, ...fs) {
  return (...as) => reduceS(go1Sync, f(...as), fs);
}